import { Component, ElementRef, EventEmitter, Input, Output, SimpleChange, ViewChild } from '@angular/core';
import { PackageType } from 'src/app/core/models/package-type.model';
import { Package } from 'src/app/core/models/package.model';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
  selector: 'hbo-confirmation-create-package-modal',
  templateUrl: './confirmation-create-package-modal.component.html',
  styleUrls: ['./confirmation-create-package-modal.component.scss']
})
export class ConfirmationCreatePackageModalComponent {

  @ViewChild('cancel') cancel!: ElementRef;

  @Input() id?: string | number;
  @Input() packageTypeId?: number;
  @Input() testDays?: number;
  originTestDays?: number;
  @Output() confirm = new EventEmitter();
  @Output() selectedPackage = new EventEmitter();
  @Output() modalsCrossData = new EventEmitter();


  @Input() head?: string;
  @Input() head5?: string;
  @Input() message?: string;

  @Input() hideConfirm?: boolean;

  @Input() packages?: Package[];

  @Input() error?: string | null;


  packageSelectedId!: any;

  alignTestDaysMessage: boolean = true;

  constructor(private configSvc: ConfigService) {

  }

  ngOnChanges(change: SimpleChange) {
    console.log(change)
    console.log(this.packages);
    //this.checkClicked(null);
    //this.originTestDays = this.testDays
    this.packageSelectedId = null;
    switch (this.error!) {
      case 'MODAL.DISMISS':
        this.abortCreatingPackage();
        break;
    }
  }

  checkClicked(_id: number | null, _testDays?: number | null) {
    this.checkEveryLicenseNew(_id);
    this.originTestDays = _testDays!;
    if (this.packageSelectedId && this.packageSelectedId == _id) {
      this.selectedPackage.emit(null);
      this.packageSelectedId = null;
    } else {
      this.packageSelectedId = _id;
      this.selectedPackage.emit(_id);
    }

  }

  checkEveryLicenseNew(_id: null | number) {
    const packageSelected: Package = this.packages?.find(pack => pack.id === _id)!;
    let appsOrigin: any[] = [];
    let appsDestiny: any[] = [];
    const packageTypeDestiny: PackageType = this.configSvc.currentConfigValue.packageTypes?.find(packageType => packageType.id === packageSelected.packageTypeId)!;
    packageTypeDestiny.appPackages.map(appPackage => appsDestiny.push(appPackage.appId));
    const packageTypeOrigin: PackageType = this.configSvc.currentConfigValue.packageTypes?.find(packageType => packageType.id === this.packageTypeId)!;
    packageTypeOrigin.appPackages.map(appPackage => appsOrigin.push(appPackage.appId));
    console.log(appsOrigin);
    console.log(appsDestiny);
    const commonReduce = appsOrigin.reduce((acc, item) => {
      if (appsDestiny.includes(item)) acc.push(item);
      return acc;
    }, []);
    if (!commonReduce.length) this.alignTestDaysMessage = false
    else this.alignTestDaysMessage = true;
  }

  abortCreatingPackage = () => {
    const modalElement = document.getElementById('confirmationCreatePackageModal');

    modalElement!.addEventListener('shown.bs.modal', () => {
      this.cancel.nativeElement.click();
    });

  }


}
